import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MarkdownDocPage } from "@core/components/docs/MarkdownDocPage";

export default function Legal() {
  const { t } = useTranslation("forms");
  const location = useLocation();
  const { docPath } = useParams<{ docPath: string }>();
  const path = location.pathname;

  // Si on accède via /docs/:docPath
  if (docPath) {
    const fileName = docPath.endsWith(".md") ? docPath : `${docPath}.md`;
    return (
      <MarkdownDocPage
        title={t("legal.docs.title")}
        docPath={fileName}
        productType="form"
        subtitle={t("legal.docs.subtitle")}
        icon="docs"
      />
    );
  }

  if (path.includes("terms")) {
    return (
      <MarkdownDocPage
        title={t("legal.terms.title")}
        docPath="cg-v.md"
        productType="form"
        subtitle={t("legal.terms.subtitle")}
        icon="legal"
      />
    );
  }

  if (path.includes("privacy-ia")) {
    return (
      <MarkdownDocPage
        title={t("legal.privacyIa.title")}
        docPath="ia-policy.md"
        productType="form"
        subtitle={t("legal.privacyIa.subtitle")}
        icon="brain"
      />
    );
  }

  if (path.includes("privacy")) {
    return (
      <MarkdownDocPage
        title={t("legal.privacy.title")}
        docPath="privacy.md"
        productType="form"
        subtitle={t("legal.privacy.subtitle")}
        icon="legal"
      />
    );
  }

  if (path.includes("legal")) {
    return (
      <MarkdownDocPage
        title={t("legal.mentions.title")}
        docPath="mentions-legales.md"
        productType="form"
        subtitle={t("legal.mentions.subtitle")}
        icon="legal"
      />
    );
  }

  // Default fallback
  return (
    <MarkdownDocPage
      title={t("legal.fallback.title")}
      docPath="cg-v.md"
      productType="form"
      subtitle={t("legal.fallback.subtitle")}
      icon="docs"
    />
  );
}
